export const LOGO_SIZE = {
  Small: 'c_pad,w_64,h_64',
  Large: 'c_pad,w_328,h_328',
};
